import { render, staticRenderFns } from "./GeoTrademark.vue?vue&type=template&id=c4b7e2f2&"
import script from "./GeoTrademark.vue?vue&type=script&lang=js&"
export * from "./GeoTrademark.vue?vue&type=script&lang=js&"
import style0 from "./GeoTrademark.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports